
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ChannelChangeGetter } from "@/components/channelChange/types";
import { Namespace } from "@/store/types";
import dayjs from "dayjs";
import apiStorageInterface from "@/services/apiStorageInterface";
import { EpgHandler } from "@/mixins/EpgHandler";
import { mixins } from "vue-class-component";
import { VodMetaDataHandler } from "@/mixins/VodMetaDataHandler";

@Component({})
export default class PlaybackItemInfo extends mixins(
  EpgHandler,
  VodMetaDataHandler
) {
  @Getter(ChannelChangeGetter.GetSource, {
    namespace: Namespace.ChannelChange
  })
  getSource!: number;

  epgUpdateTimer = 0;

  async mounted(): Promise<void> {
    if (this.getActiveVodItem && this.getActiveVodItem.id === 0) {
      this.channelList = await apiStorageInterface.fetchCustomChannelList();
      this.updateActiveEpgItem();
      //for tracking where we are on the timeline and update epgItem if we are out of bounds
      this.epgUpdateTimer = setInterval(() => {
        let currentTime = dayjs().subtract(this.getOffset, "second"); //current time adjusted for any offset made during rewinding
        this.secondsElapsed++;
        if (
          currentTime.isAfter(this.getActiveEpgItem.epgEndtime) &&
          this.getOverlayMenuOpen !== "ContentList"
        ) {
          this.updateActiveEpgItem();
        }
      }, 1000);
    }
  }

  get progressIndicatorVal(): number {
    const adjustedOffset =
      this.getOverlayMenuOpen === "ChannelList" ? 0 : this.getOffset;
    const adjustedSecondsElapsed = this.secondsElapsed - adjustedOffset;
    return Math.round(adjustedSecondsElapsed / this.secondsPerPercent);
  }

  beforeDestroy(): void {
    clearInterval(this.epgUpdateTimer);
  }
}
